import { http, HttpResponse } from 'msw';

export const pixHandlers = [
  http.get('**/pix/charges/:pixChargeKey/feedback', () => HttpResponse.json(null)),
];
